import { render, staticRenderFns } from "./sendMessage.vue?vue&type=template&id=7adc4abc&scoped=true&"
import script from "./sendMessage.vue?vue&type=script&lang=js&"
export * from "./sendMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adc4abc",
  null
  
)

export default component.exports